import Table from "@mui/material/Table";
import { HintedLabel } from "../../ui/HintedLabel";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import type { SiteListItem } from "./useSiteList";
import type { SiteSelectionState, SelectableSite } from "./SiteSelection";
import { SiteSelection } from "./SiteSelection";
import { SiteRow } from "./SiteRow";

export type PasswordCellState =
  | { kind: "hidden" }
  | { kind: "loading" }
  | { kind: "revealed"; value: string }
  | { kind: "error"; message: string };

interface SiteDataGridProps {
  items: SiteListItem[];
  selection: SiteSelectionState;
  onToggleSite: (site: SelectableSite) => void;
  onToggleCurrentPage: (pageSites: SelectableSite[]) => void;
}

export const COLSPAN_FULL = 25;

export function SiteDataGrid(props: SiteDataGridProps) {
  const { items, selection, onToggleSite, onToggleCurrentPage } = props;

  const pageSiteIds = items.map((item) => item.id);
  const allSelected = SiteSelection.areAllPageRowsSelected(selection, pageSiteIds);
  const partialSelected = SiteSelection.isPartialPageSelection(selection, pageSiteIds);

  const toggleAll = () => {
    onToggleCurrentPage(items.map((site) => SiteSelection.toSelectableSite(site)));
  };

  const toggleOne = (item: SiteListItem) => {
    onToggleSite(SiteSelection.toSelectableSite(item));
  };

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                checked={allSelected}
                indeterminate={partialSelected}
                onChange={toggleAll}
              />
            </TableCell>
            <TableCell />
            <TableCell>URL</TableCell>
            <TableCell>Регион</TableCell>
            <TableCell>Тип</TableCell>
            <TableCell>Селлер</TableCell>
            <TableCell align="right">DR</TableCell>
            <TableCell align="right">Organic KW</TableCell>
            <TableCell align="right">Возраст</TableCell>
            <TableCell align="right">Доступов</TableCell>
            <TableCell align="right">
              <HintedLabel hint="Количество валидных каналов: каждый Credential с любым valid method + 1 если plugin valid">Валидных каналов</HintedLabel>
            </TableCell>
            <TableCell align="center">
              <HintedLabel hint="Статус плагина Link Factory как канала публикации статей">Плагин (articles)</HintedLabel>
            </TableCell>
            <TableCell align="center">
              <HintedLabel hint="Статус плагина Link Factory как homepage-канала публикации">Плагин (homepage)</HintedLabel>
            </TableCell>
            <TableCell align="center">
              <HintedLabel hint="Статус плагина Link Factory как sitewide-канала публикации">Плагин (sitewide)</HintedLabel>
            </TableCell>
            <TableCell align="center">
              <HintedLabel hint="Статус плагина Link Factory как канала удаления ссылок (link-removal)">Плагин (link-removal)</HintedLabel>
            </TableCell>
            <TableCell align="right">
              <HintedLabel hint="Опубликовано статей">Статьи</HintedLabel>
            </TableCell>
            <TableCell align="right">
              <HintedLabel hint="Опубликовано на homepage">Homepage</HintedLabel>
            </TableCell>
            <TableCell align="right">
              <HintedLabel hint="Ошибки публикаций статей">Ошибки (ст)</HintedLabel>
            </TableCell>
            <TableCell align="right">
              <HintedLabel hint="Ошибки публикаций homepage">Ошибки (hp)</HintedLabel>
            </TableCell>
            <TableCell>Посл. публ. (статьи)</TableCell>
            <TableCell>Посл. публ. (homepage)</TableCell>
            <TableCell>Посл. публ. (sitewide)</TableCell>
            <TableCell>Последняя проверка</TableCell>
            <TableCell>Добавлен</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <SiteRow
              key={item.id}
              item={item}
              selected={SiteSelection.isSiteSelected(selection, item.id)}
              onToggle={() => toggleOne(item)}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
